<template>
  <aside v-if="notices.length" class="news-notices" aria-label="Tärkeät tiedotteet">
    <article v-for="article in notices" :key="article.slug" class="news-notice">
      <p class="news-eyebrow">Tärkeä tiedote</p>
      <h2>{{ article.title }}</h2>
      <p>{{ article.summary }}</p>
      <router-link :to="{ name: 'NewsArticle', params: { slug: article.slug } }" class="news-read-link">Lue tiedote →</router-link>
    </article>
  </aside>
</template>

<script setup>
import { computed } from 'vue';
import { getActiveNotices } from '../utils/news';
import { useNewsDate } from '../composables/useNewsDate';
const today = useNewsDate();
const notices = computed(() => getActiveNotices(today.value));
</script>

<style src="../styles/news.css"></style>
